import { IdCodNomeDTO } from '@/interfaces/base-dto';
// import IClient from '@/interfaces/client';
import IClientUnit, { IAddress } from '@/interfaces/clientUnit';
import ClientModel from './client-model';
import { IdNomeDTO } from '@/interfaces/base-dto';

export default class ClientUnitModel {
  public id: string;
  public nome: string;
  public areaGeografica: IdNomeDTO;
  public cliente: ClientModel;
  public cnpj: string;
  public imagem: string;
  public convenios: any[];
  public setores: any[];
  public templates: IdCodNomeDTO[];
  public unidadesEmpresariais: any[];
  public produtos: any[];
  public enderecos: IAddress[];
  public ativo: boolean;
  public validarPrescricao: boolean;
  public rotasEntrega: any[];
  public usoBolsaMulticompart: any;
  public minBolsaMulticompart: number;
  public maxBolsaMulticompart: number;
  public diasAntecedProdBolsaMulti: number;
  public diasAntecedEntrBolsaMulti: number;
  public diasEntregaBolsaMulticompart: any[];
  public usoObservacaoPrescricao: boolean;
  public usoTerapia: boolean;
  public terapias: IdNomeDTO[];
  public produtosEnterais: IdNomeDTO[];
  public enteralTipoCalculo: IdNomeDTO;
  public viaFaturamento: IdNomeDTO;
  public agendamentoProducao: any;
  public horaAgendamentoProducao: string;
  public pendenciaPrescWhatsappAutoMinutos: number;
  public pendenciaPrescWhatsappTolerPrazo: number;
  public usoPropostaFrete: boolean;
  public campoRegistroObrigatorio: boolean;
  public registroValidacaoRegexp: string;
  public registroValidacaoExplic: string;

  constructor(_initialValues?: IClientUnit) {
    const initialValues = _initialValues || {
      id: '',
      nome: '',
      areaGeografica: null,
      cliente: new ClientModel(),
      cnpj: '',
      imagem: '',
      convenios: [],
      setores: [],
      templates: [],
      unidadesEmpresariais: [],
      produtos: [],
      enderecos: [],
      ativo: true,
      validarPrescricao: false,
      rotasEntrega: [],
      usoBolsaMulticompart: null,
      minBolsaMulticompart: null,
      maxBolsaMulticompart: null,
      diasAntecedProdBolsaMulti: null,
      diasAntecedEntrBolsaMulti: null,
      diasEntregaBolsaMulticompart: [],
      usoObservacaoPrescricao: false,
      usoTerapia: false,
      terapias: [],
      produtosEnterais: [],
      enteralTipoCalculo: null,
      viaFaturamento: null,
      agendamentoProducao: null,
      horaAgendamentoProducao: null,
      pendenciaPrescWhatsappAutoMinutos: null,
      pendenciaPrescWhatsappTolerPrazo: null,
      usoPropostaFrete: false,
      campoRegistroObrigatorio: false,
      registroValidacaoRegexp: null,
      registroValidacaoExplic: null
    };

    this.id = initialValues.id;
    this.nome = initialValues.nome;
    this.areaGeografica = initialValues.areaGeografica;
    this.cliente = initialValues.cliente;
    this.cnpj = initialValues.cnpj;
    this.imagem = initialValues.imagem;
    this.convenios = initialValues.convenios;
    this.setores = initialValues.setores;
    this.templates = initialValues.templates;
    this.unidadesEmpresariais = initialValues.unidadesEmpresariais;
    this.produtos = initialValues.produtos;
    this.enderecos = initialValues.enderecos;
    this.ativo = initialValues.ativo;
    this.validarPrescricao = initialValues.validarPrescricao;
    this.rotasEntrega = initialValues.rotasEntrega;
    this.usoBolsaMulticompart = initialValues.usoBolsaMulticompart;
    this.minBolsaMulticompart = initialValues.minBolsaMulticompart;
    this.maxBolsaMulticompart = initialValues.maxBolsaMulticompart;
    this.diasAntecedProdBolsaMulti = initialValues.diasAntecedProdBolsaMulti;
    this.diasAntecedEntrBolsaMulti = initialValues.diasAntecedEntrBolsaMulti;
    this.diasEntregaBolsaMulticompart = initialValues.diasEntregaBolsaMulticompart;
    this.usoObservacaoPrescricao = initialValues.usoObservacaoPrescricao;
    this.usoTerapia = initialValues.usoTerapia;
    this.terapias = initialValues.terapias;
    this.produtosEnterais = initialValues.produtosEnterais;
    this.enteralTipoCalculo = initialValues.enteralTipoCalculo;
    this.viaFaturamento = initialValues.viaFaturamento;
    this.agendamentoProducao = initialValues.agendamentoProducao;
    this.horaAgendamentoProducao = initialValues.horaAgendamentoProducao;
    this.pendenciaPrescWhatsappAutoMinutos = initialValues.pendenciaPrescWhatsappAutoMinutos;
    this.pendenciaPrescWhatsappTolerPrazo = initialValues.pendenciaPrescWhatsappTolerPrazo;
    this.usoPropostaFrete = initialValues.usoPropostaFrete;
    this.campoRegistroObrigatorio = initialValues.campoRegistroObrigatorio;
    this.registroValidacaoRegexp = initialValues.registroValidacaoRegexp;
    this.registroValidacaoExplic = initialValues.registroValidacaoExplic;
  }

  public validate(): boolean {
    return !!this.nome;
  }

  public toJson(): any {
    const produtos = this.produtos.map((item) => {
      return {
        id: item.id,
      };
    });

    return {
      id: this.id,
      cnpj: this.cnpj,
      imagem: this.imagem,
      convenios: this.convenios,
      setores: this.setores,
      templates: this.templates,
      unidadesEmpresariais: this.unidadesEmpresariais,
      produtos,
      enderecos: this.enderecos,
      ativo: this.ativo,
      validarPrescricao: this.validarPrescricao,
      usoBolsaMulticompart: this.usoBolsaMulticompart,
      minBolsaMulticompart: this.minBolsaMulticompart,
      maxBolsaMulticompart: this.maxBolsaMulticompart,
      usoObservacaoPrescricao: this.usoObservacaoPrescricao,
      usoTerapia: this.usoTerapia,
      terapias: this.terapias,
      produtosEnterais: this.produtosEnterais,
      enteralTipoCalculo: this.enteralTipoCalculo,
      viaFaturamento: this.viaFaturamento,
      agendamentoProducao: this.agendamentoProducao,
      horaAgendamentoProducao: this.horaAgendamentoProducao,
      pendenciaPrescWhatsappAutoMinutos: this.pendenciaPrescWhatsappAutoMinutos
    };
  }
}
